import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useGeolocation from '#/shared/hooks/useGeolocation';
import useCurrentLocation from '#/shared/hooks/useCurrentLocation';

function CurrentLocationManager() {
  const { startPositionWatch, clearPositionWatch, geolocationApproved } =
    useGeolocation();
  const { isManualLocation } = useCurrentLocation();
  const watchId = useSelector(s => s.shared.location.watchId);
  const geolocationPause = useSelector(s => s.shared.location.geolocationPause);

  useEffect(() => {
    if (
      geolocationApproved &&
      !isManualLocation &&
      !watchId &&
      !geolocationPause
    ) {
      startPositionWatch();
    } else if (geolocationPause) {
      if (watchId) clearPositionWatch(watchId);
    }
  }, [
    geolocationApproved,
    geolocationPause,
    startPositionWatch,
    isManualLocation,
    watchId,
    clearPositionWatch,
  ]);

  useEffect(() => {
    const isSwitchingToManual = isManualLocation && watchId;
    if (isSwitchingToManual) clearPositionWatch(watchId);
  }, [clearPositionWatch, isManualLocation, watchId]);

  useEffect(() => {
    return () => {
      if (watchId) clearPositionWatch(watchId);
    };
  }, [clearPositionWatch, watchId]);
  return null;
}

export default CurrentLocationManager;
